import { useLocation } from 'react-router';
import { MAIN_URL } from '@lib/constants';

export const useWindowLocation = (): string => {
  const location = useLocation();
  return `${MAIN_URL}${location.pathname}`;
};
